import { render, staticRenderFns } from "./DifficultyBadge.vue?vue&type=template&id=73755054"
import script from "./DifficultyBadge.vue?vue&type=script&lang=js"
export * from "./DifficultyBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports